export default __webpack_public_path__ + "static/media/medic-illustration.42653543.svg";